export default __webpack_public_path__ + "static/media/WORKING TRAINING SYSTEM IN PNEUMATIC ACCESORIES SIMULATOR.0bc2a10c.JPG";